/**
 * ReportController.java 对应的 model
 */

import Model from './model'
const model = new Model()
class Report {

    /**
     * 保存评语
     * @param testId 测试id
     * @param remark 评语
     * @returns {*}
     */
    static saveRemark(testId, remark) {
        return model.post('report/remarkReport', {testId, remark})
    }

    /**
     * 归档报告
     * @param testId 测试id
     * @returns {*}
     */
    static archive(testId) {
        return model.post('report/archive', `[${testId}]`)
    }

    /**
     * 取消归档报告
     * @param testId 测试id
     * @returns {*}
     */
    static undoArchive(testId) {
        return model.post('report/undo', `[${testId}]`)
    }

    /**
     * 取消归档报告
     * @param testId 测试id
     * @returns {*}
     */
    static del(testId) {
        return model.post(`report/deleteReport/${testId}`)
    }

    /**
     * 更新报告标记
     * @param testId 测试id
     * @param tags Array 报告标记数组
     * @returns {*}
     */
    static updateTags(testId, tags) {
        return model.post('report/updateTags', {
            testIds: testId,
            tags: tags
        })
    }

    /**
     * 每一道题打分、标记
     * @param params post参数
     * @returns {*}
     */
    static saveQuestionRemark(params) {
        return model.post('report/scoreQuestion', params)
    }

    /**
     * 获得编程题详细信息 (用于运行编程题功能)
     * @param testId 测试 id
     * @param questionId 题目 id
     * @returns {*}
     */
    static getProgramQuestion(testId, questionId) {
        return model.post('report/getProgramQuestion?testId=' + testId + '&questionId=' + questionId)
    }

    /**
     * 获取报告列表
     * @param paperId 试卷Id
     * @param clazzId 群组Id
     * @returns
     */
    static getReports(paperId, clazzId) {
        return model.post('report/getReports', {paperId, clazzId, start: 0, rows: 10000})
    }

    /**
     * 报告截图
     * @param testId
     * @returns {*}
     */
    static getReportPics(testId) {
        return model.post(`report/getReportFacePictures?testId=${testId}`)
    }

    /**
     * 获取已答试卷
     * */
    static getSelfReports(params) {
        return model.post('report/getSelfReports', params)
    }

    /**
     * 获取已答试卷
     * */
    static getSelfReportsCount(params) {
        return model.post('report/getSelfReportsCount', params)
    }
}
export default Report



// WEBPACK FOOTER //
// ./bootsets/models/report.js